import styled from 'styled-components'

import { media } from '@/theme/common'

// Note: FiltersWrapper (table-group.styled.ts) gives every filter a generic desktop width of
// 16rem via `> *:not([data-clear-filters-button])` - fine for a Select's placeholder text, but
// too narrow for the Amenities & spaces select once a few options are selected, which clipped
// its value instead of fitting. 22.5rem matches the literal width NavigationDatePicker uses in
// table-group.styled.ts.
//
// && (doubling this styled-component's own generated class) is required, not optional here -
// FiltersWrapper's selector isn't just one class: `:not([data-clear-filters-button])` itself
// carries the specificity of the attribute selector inside it, so the full selector is two
// classes' worth of specificity, not one. A plain, undoubled wrapper class would tie rather than
// win, and which one applies would come down to unpredictable style-injection order. && makes
// this selector's specificity match FiltersWrapper's exactly, and it wins the resulting tie by
// being injected later (this module is imported after `@/components/layout/table-group` in
// reservations-dashboard.page.tsx) - the same pattern already used for
// AmenitySpaceSelectWrapper in time-blocks.styled.ts.
//
// Scoped to media.up('sm') only, deliberately - FiltersWrapper's own mobile rules (width: 100%
// below sm, then width: auto + flex: 1 1 0 to share a row with the icon-actions group) already
// do the right thing below this breakpoint. Setting an unconditional width here would tie with
// those mobile-scoped declarations at the same specificity too, and - unlike the desktop case,
// where winning that tie is exactly what's wanted - risk overriding FiltersWrapper's own mobile
// behavior depending on injection order. Not declaring width for that range at all sidesteps the
// tie entirely: FiltersWrapper's mobile rules simply apply unopposed.
export const AmenitySpaceFilterWrapper = styled.div`
  && {
    ${media.up('sm')} {
      width: 22.5rem;
      max-width: 100%;
    }
  }
`
